$(document).ready(function() {
    $('.blog-product-slider-lw-product').slick({
        slidesToShow: 3,
        variableWidth: false,
        swipe: true,
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: "<img style='width: 50px; height: 50px; z-index: 500' class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/2513/7040/files/arrow-left.png?10316'>",
        nextArrow: "<img style='width: 50px; height: 50px; z-index: 500' class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/2513/7040/files/arrow-right.png?10316'>",
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: true,
                centerMode: true,
                centerPadding: '40px',
                slidesToScroll: 1,
                slidesToShow: 1
            }
        }, {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '0px',
                slidesToScroll: 1,
                slidesToShow: 1
            }
        }]
    });
});